module.exports = __webpack_public_path__ + "static/media/Nokia 220 Blue.f782b53c.png";